import { request } from "../../../services/api"
import type { BaseApiResponse } from "../../../types/api.ts"
import type { MilestoneDependency } from "../types/project-milestone-dependency.types.ts"

const BASE_URL = `/project-management/milestone-dependencies`

const PATHS = {
  getMilestoneDependencies: `${BASE_URL}/`,
  createMilestoneDependency: `${BASE_URL}/`,
  patchMilestoneDependency: (id: string) => `${BASE_URL}/${id}/`,
  deleteMilestoneDependency: (id: string) => `${BASE_URL}/${id}/`
}

export interface MilestoneDependencyWriteData {
  source_milestone: string
  target_milestone: string
  type: number
  lag_days: number
}

// Always scoped to one project — the backend returns an empty list rather
// than the full cross-tenant table when neither filter is given. It sends the
// whole graph as a bare array, unpaginated, because the scheduling engine
// drops any edge whose source it cannot see and so a partial page would
// silently compute a wrong schedule rather than degrade.
export const getMilestoneDependencies = async (projectId: string) => {
  return request.api.get<MilestoneDependency[], BaseApiResponse<unknown>>(
    PATHS.getMilestoneDependencies,
    { project: projectId }
  )
}

export const createMilestoneDependency = async (
  data: MilestoneDependencyWriteData
) => {
  return request.api.post<
    BaseApiResponse<MilestoneDependency>,
    BaseApiResponse<unknown>
  >(PATHS.createMilestoneDependency, data)
}

export const patchMilestoneDependency = async (
  id: string,
  data: Partial<MilestoneDependencyWriteData>
) => {
  return request.api.patch<
    BaseApiResponse<MilestoneDependency>,
    BaseApiResponse<unknown>
  >(PATHS.patchMilestoneDependency(id), data)
}

export const deleteMilestoneDependency = async (id: string) => {
  return request.api.delete<BaseApiResponse<unknown>, BaseApiResponse<unknown>>(
    PATHS.deleteMilestoneDependency(id)
  )
}
